<template>
  <div>
    <HEADER></HEADER>
     <BANNER :src="banner_bg" h1='媒体报道与行业荣誉'  >
    </BANNER>
    <div class="w">
      <div class="coverage-card-list" >           
          <div class="c-card" v-for="(item,index) in information_list" :key="index">
            <div class="card-img">
              <img
              style="width:100%;height:170px;border-radius:6px"
              slot="cover"
              alt="example"
              :src="item.imgs"
              />
            </div>            
            <h5>{{item.title}}</h5>
            <p>{{item.summary}}</p>
            <div class="detail" @click="lookDetail(item.id)">
              <span>查看详情</span>
              <img :src="require('../assets/img/coverage/right.png')" alt>
            </div>
          </div>
        </div> 
        <div class="card-page">
          <el-pagination
            layout="prev, pager, next"
            :page-size='per_page'
            :total="total"
            prev-text='<<'
            next-text='>>'
            @current-change='currentChange'
            >
          </el-pagination>
        </div> 
    </div>
    
    <WHO></WHO>
    <FOOTER></FOOTER>
  </div>  
</template>
<script>
import HEADER from "../components/header.vue";
import FOOTER from "../components/footer.vue";
import WHO from "../components/who.vue";
import '../assets/iconfonts/iconfont.css';
import BANNER from "../components/banner.vue";
import banner_bg from '../assets/img/school/nc_school.jpg';
export default {
  components: {
    HEADER,
    FOOTER,
    WHO,
    BANNER,
  },
  data(){
    return{
      banner_bg:banner_bg,
      information_list:[],
      page:1,
      per_page:6,
      total:null
    }
  },
  created(){
    this.getInformation(1)
  },
  methods:{
    //-------------获取详情-------------
    getInformation(page){
      fetch("https://www.ncmps.com/api/article/list",{
              method:"POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
                },
              body:JSON.stringify({
                page:page,
                per_page:this.per_page
              })
          }).then(res=>{
              res.json().then(res=>{
                if (res.code === 0) {
                  this.information_list = res.data.data || []
                  this.total = res.data.total
                }
              })               
          })
    },
    //分页
    currentChange(page){
      this.getInformation(page)
      scrollTo({
                  top:0,
                  behavior: "smooth" 
              });
    },
    lookDetail(id){
      this.$router.push({path:'/detail',query: {id}})
    }
  },
  mounted(){  
    
  }
};
</script>
<style lang='less'>
@import url("../assets/css/coverage.less");
</style>
